export enum BookingType {
  INSTANT_BOOKING = "instantBooking",
  REQUEST_TO_BOOK = "requestToBook",
}
